import moment from 'moment-timezone';
import { Tag } from 'sonata-react-components';

import './bestDayTag.scss';

type Props = {
  id: string;
  /** ISO date string, or null/undefined when no best day is known yet. */
  value: string | null | undefined;
};

type DayKey = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

const DAY_KEYS: DayKey[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function getDayKey(date: moment.Moment): DayKey {
  return DAY_KEYS[date.day()] ?? 'monday';
}

export default function BestDayTag({ id, value }: Readonly<Props>) {
  if (!value) {
    return <span className="bestDayTag__empty">N/A</span>;
  }
  const date = moment.utc(value);
  if (!date.isValid()) {
    return <span className="bestDayTag__empty">{value}</span>;
  }
  const dayKey = getDayKey(date);
  const label = date.format('MMM D / dddd');

  return (
    <Tag className={`bestDayTag bestDayTag--${dayKey}`} id={id} status="custom" tiny>
      {label}
    </Tag>
  );
}
